/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M7.5 0C8.3284 0 9 .6716 9 1.5S8.3284 3 7.5 3 6 2.3284 6 1.5 6.6716 0 7.5 0Zm0 10.5c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5S6 12.8284 6 12s.6716-1.5 1.5-1.5Zm0 10.5c.8284 0 1.5.6716 1.5 1.5S8.3284 24 7.5 24 6 23.3284 6 22.5 6.6716 21 7.5 21Zm9-21c.8284 0 1.5.6716 1.5 1.5S17.3284 3 16.5 3 15 2.3284 15 1.5 15.6716 0 16.5 0ZM18 12c0-.8284-.6716-1.5-1.5-1.5S15 11.1716 15 12s.6716 1.5 1.5 1.5S18 12.8284 18 12Zm0 10.5c0-.8284-.6716-1.5-1.5-1.5s-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5Z"
    clipRule="evenodd"
  />,
  'Dragndrop'
);
